import { render, staticRenderFns } from "./conjuntos.vue?vue&type=template&id=be913a46"
import script from "./conjuntos.vue?vue&type=script&lang=js"
export * from "./conjuntos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports